import {
    Assessment,
    CloudUpload,
    AutoFixHigh,
    TrackChanges,
    MenuBook,
    ArrowForward,
    Download,
    People,
    Group,
    PublicRounded,
  } from '@mui/icons-material';

import BarChart from '@mui/icons-material/BarChart';
import ChatBubbleOutline from '@mui/icons-material/ChatBubbleOutline';
import AccessTime from '@mui/icons-material/AccessTime';


  
  // (Feature arrays remain the same)
  export const primaryFeatures = [
    {
      icon: <TrackChanges fontSize="large" />,
      title: 'AI-Powered Insights',
      description:
        'Leverage artificial intelligence to automatically highlight students or sessions needing attention.',
      color: 'primary',
    },
    {
      icon: <Assessment fontSize="large" />,
      title: 'Streamlined Digital Assessments',
      description:
        'Transition to fully digital assessments to reduce paper waste and eliminate manual grading.',
      color: 'success',
    },
    {
      icon: <MenuBook fontSize="large" />,
      title: 'Centralized Session Materials',
      description:
        'Access and manage all required materials for each tutoring session in one organized place.',
      color: 'secondary',
    },
    {
      icon: <CloudUpload fontSize="large" />,
      title: 'Effortless Data Management',
      description:
        'Easily add or update students and tutors in large quantities with just a few clicks.',
      color: 'warning',
    },
    {
      icon: <BarChart fontSize="large" />,
      title: 'Deep Analytics and Reporting',
      description:
        'Provide real-time data on student progress, tutor effectiveness, and program-wide metrics.',
      color: 'info',
    },
    {
      icon: <ChatBubbleOutline fontSize="large" />,
      title: 'Sentiment Analysis',
      description:
        'Use sentiment analysis on employee surveys to gauge morale and identify training needs.',
      color: 'default',
    },
    {
      icon: <AccessTime fontSize="large" />,
      title: 'Easy Tutor Insights',
      description:
        'Track and analyze session-level data to provide a richer picture of a tutor\'s performance.',
      color: 'error',
    },
    {
      icon: <PublicRounded fontSize="large" />,
      title: 'Resource Reduction',
      description:
        'Provide online assessments to significantly reduce paper usage and other physical resources.',
      color: 'success',
    }
  ];
    
export const additionalFeatures = [
      {
        icon: <Download />,
        title: 'End of year data',
        desc: 'Export all student session records easily for reporting and analysis.',
      },
      {
        icon: <People />,
        title: 'View Student Data',
        desc: 'See growth, attendance, and performance for every student.',
      },
      {
        icon: <Group />,
        title: 'Track Tutor Sessions',
        desc: 'Monitor tutor activity and session completion across your team.',
      },
];

export const data_feature_link = "https://do7m5rg8y8wco.cloudfront.net/static_frontend_images/image_data.png"
export const ai_feature_link = "https://do7m5rg8y8wco.cloudfront.net/static_frontend_images/image_gen.png"
export const eco_feature_link = "https://do7m5rg8y8wco.cloudfront.net/static_frontend_images/image_eco_as.png"
export const tutor_data_link = "https://do7m5rg8y8wco.cloudfront.net/static_frontend_images/tutor_data.png"
export const tutor_data_details_link = "https://do7m5rg8y8wco.cloudfront.net/static_frontend_images/tutor_info.png"

export const student_data_link = "https://do7m5rg8y8wco.cloudfront.net/static_frontend_images/student_data.png"
export const student_data_details_link = "https://do7m5rg8y8wco.cloudfront.net/static_frontend_images/student_info.png"
export const organization_link = "https://do7m5rg8y8wco.cloudfront.net/static_frontend_images/Organization.png"
export const admin_data_link = "https://do7m5rg8y8wco.cloudfront.net/static_frontend_images/dashboard_updated.mp4"

export const ai_feature = [
    'Cut overhead by instantly producing all educational materials digitally',
    'Generate assessments, quizzes, assignments, with a simple prompt.',
    'You can say: "This assessment will cover solving 2,3 step linear equations".',
    'Generate study guide and lesson plans in parallel!'
];

export const eco_feature = [
    'Eliminating printed quizzes and homework saves millions of sheets of paper annually.',
    'Online data easily downloadable and presentable with various graphs insights.',
    'Generate results and grades instantly'
  ];


export const data_feature = [
    'Real-time tracking of tutor-student sessions for accurate attendance records',
    'Interactive dashboard with performance insights and engagement metrics',
    'Trend analysis to identify learning patterns and highlight areas for intervention',
    'Centralized repository of session details, assessments, and notes',
]

export const tutor_data_ = [
  {
    "link": tutor_data_link,
    "title": "Tutor oversight",
    "features": [
      "Gain clear visibility into tutor activities, including session length, assessments, and daily interactions.",
      "Monitor key performance metrics such as session attendance and engagement through a unified dashboard.",
      "Instantly download all tutor data for comprehensive analysis and record-keeping."
    ]
  },
  {
    "link": tutor_data_details_link,
    "title": "Tutor oversight details",
    "features": [
      "Gain detailed insights into tutor interactions, including session length and assessments conducted."
    ]
  }
]

export const student_data_ = [
  {
    "link": student_data_link,
    "title": "Student Oversight",
    "features": [
      "Get a clear view of student activities, including session length, assessments, and overall engagement.",
      "Monitor student performance, attendance, and sessions through a unified data hub for easy insights.",
      "Instantly download all student data for streamlined quarterly and end-of-year reporting."
    ]
  },
  {
    "link": student_data_details_link,
    "title": "Student Oversight Details",
    "features": [
      "Access comprehensive student assessment and session history.",
      "Evaluate student performance at a glance with a streamlined dashboard."
    ]
  }
]

export const math_ai_example_link = "https://do7m5rg8y8wco.cloudfront.net/static_frontend_images/math_ai_example.mp4"
export const tutor_create_session_link = "https://do7m5rg8y8wco.cloudfront.net/static_frontend_images/create_session.mp4"
export const student_analytics_link = "https://do7m5rg8y8wco.cloudfront.net/static_frontend_images/student_analytics.mp4"
export const file_download = "https://do7m5rg8y8wco.cloudfront.net/static_frontend_images/file_download.mp4"

export const location_info_link = "https://do7m5rg8y8wco.cloudfront.net/static_frontend_images/location_info.png"
export const tutor_info_link  = "https://do7m5rg8y8wco.cloudfront.net/static_frontend_images/tutor_info_sidebar.png"


export const video_data_ = [
  {
    "link": student_analytics_link,
    "title": "Student Report Cards",
    "header": "Data-Driven Insights",
    "features": [
      "Generate personalized student insights based on collected data for targeted support.",
      "Access visual aids for personalized intervention assistance."
    ]
  },
  {
    "link": math_ai_example_link,
    "title": "Generating a Quiz",
    "header": "LLM-Driven Technology",
    "features": [
      "Effortlessly generate quizzes with a simple, conversational sentence.",
      "Example: 'Create a quiz aligning with California Math Common Core standard 5.OA.1, using parentheses, brackets, or braces in numerical expressions.'"
    ]
  },
  {
    "link": tutor_create_session_link,
    "title": "Create a Session",
    "header": "Database-Driven Technology",
    "features": [
      "Provide tutors with a specialized dashboard for streamlined workflows.",
      "Enable tutors to create and manage sessions in a matter of seconds."
    ]
  },
  {
    "link": file_download,
    "title": "Download Data",
    "header": "Data-Driven Reporting",
    "features": [
      "Easily download end-of-semester, quarterly, or yearly data for students, tutors, assessments, and sessions.",
      "Simplify and unify all data reporting for seamless analysis."
    ]
  }
]
export const admin_data = {
  "link": admin_data_link,
  "title": "Dashboard",
  "features": [
      'Ingest all your data Seamlessly import custom data, program details, sessions, assessments, and materials to gain a complete overview.',
      'Rich insights dashboard: Monitor student and tutor performance with an intuitive dashboard that helps you pinpoint trends and take action.',
      'Unified monitoring: Consolidate data monitoring to quickly identify and eliminate root causes of issues.'
    ]
}
export const organization_data = {
  "link": organization_link,
  "title": "Organization representation",
  "features": [
      'Regional layer allows you to span accross multiple regions while organizing your data, staff.',
      'Each region has locations attached, and are sortable by semester date range.',
      'Each school might have different programs with different students, assessments, materials etc.',
      'Each session created is organized by location, semester, program.',
    ]
}


export const sort_data = [
  {
    "title": "One View. Every Insight.",
    "subtitle": "Business Analytics Dashboard",
    "description": "Empower smarter business decisions with real-time analytics, trends, and performance data—all in a single glance.",
    "image": location_info_link
  },
  {
    "title": "Know Your Team. Grow Your Impact.",
    "subtitle": "Employee Performance Overview",
    "description": "A side-by-side view of employee performance, productivity, and engagement—turning daily data into actionable business intelligence.",
    "image": tutor_info_link
  }
];